import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function Altezza({ idVariant = '', className }: Props) {
  return (
    <IconBase name="altezza" w={20} className={className}>
      <path fillRule="evenodd" clipRule="evenodd" d="M6.38126 5.01798L10.0171 1.38214L13.6529 5.01798L12.4746 6.19631L10.8504 4.57297V15.4288L12.4754 13.8038L13.6538 14.9821L10.0171 18.6188L6.38126 14.9821L7.55876 13.8038L9.18376 15.4288V4.57297L7.55876 6.19631L6.38126 5.01798Z" fill="currentColor"/>
    </IconBase>
  )
}

export default Altezza
